const removeUndefined = (obj) => {
  const keys = Object.keys(obj);

  keys.forEach(
    (key) => {
      if (obj[key] === undefined) {
        delete obj[key];
      }
    }
  );

  return { ...obj };
};

export default removeUndefined;
